//imports
import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';

//controls
import { Container, Paper } from '@mui/material';
import Tabs, { TabContainer } from 'Components/Tabs';
import { useDispatch, useSelector } from "react-redux";
import { HasPermission } from "Core/security"
import { NotificationManager } from 'Components/Notifications';

//views
import RoutesTracker from '../routesTracker';
import Templates from '../templates';

import FSMDeleteRoute from '../templates/components/deleteRoute'

import {
  reset as resetRouteManagerCreateEditModalMain
} from '../templates/components/createEditRouteModalMain/redux/slice'

import CreateEditRouteModalMain from '../templates/components/createEditRouteModalMain'
import { routesEditPanelRouteGetRoute } from '../templates/components/editPanelRoute/redux/slice'

import {
  openModalDeleteRoutePoints,
  reset as resetDeleteRoutePoint
} from '../templates/components/deleteRoutePoint/redux/slice'

const RoutesMainView = (props) => {
  //intl
  const { messages, locale } = useIntl();

  const dispatch = useDispatch()

  //Global state
  const user = useSelector((state) => state.securityRedux.user);
  const openModalDeleteRoute = useSelector(state => state.routesManagerDeleteRedux?.openModal);
  const openModalDeleteRoutePointsVar = useSelector(state => state.routesManagerDeleteRoutePoint?.open);
  const deleteAllRoutePointsResponse = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.deleteAllRoutePointsResponse);
  const erorrRoutes = useSelector(state => state.routesManagedRedux.erorrRoutes);
  const routeManageCreateEditRouteModalMain = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.route);
  const routeToEditPanel = useSelector(state => state.routesManagerEditPanelRouteRedux?.route);
  const openModalCreateEditRoute = useSelector(state => state.routesManagedCreateEditRouteModalMainRedux?.open);
  const route = routeManageCreateEditRouteModalMain || routeToEditPanel

  useEffect(() => {
    if (openModalDeleteRoutePointsVar && (deleteAllRoutePointsResponse)) {
      if (erorrRoutes) {
        NotificationManager.error(
          messages['routes_error'],
          messages['error'],
          3000,
          null,
          null,
          'warning',
        );
      } else {
        NotificationManager.success(
          messages['fsmRoute_modal_delete_success'],
          messages['success'],
          3000,
          null,
          null,
          'success',
        );
        
      }
      dispatch(resetRouteManagerCreateEditModalMain({deleteAllRoutePointsResponse : false, errorOnMap: null}))
      if(route?.id > 0){
        dispatch(routesEditPanelRouteGetRoute({id: route?.id}))
      }
      dispatch(openModalDeleteRoutePoints({ open: false, routeId: 0 }))
      dispatch(resetDeleteRoutePoint())
    }
    
  }, [deleteAllRoutePointsResponse, openModalDeleteRoutePointsVar]);

  const getTabs = () => {
    let tabs = [
      { // TODO submodule-approved
        label: messages['module_routes_routes_tracker'],
        master: "",
        subUser: [241],
        render: () => {
          return <RoutesTracker />
        }
      },
      {  // TODO submodule-approved
        label: messages["module_routes_routes_template"],
        master: "",
        subUser: [241],
        render: () => {
          return <Templates  />
        }
      }
    ];
    
    let result = [
      ...tabs.filter(tab => HasPermission(user, tab.master, tab.subUser)),
    ]

    return result;
  }

  

  return (
    <div>  
      <Container id={'containerManage'} maxWidth={false} className="container-view">
        <Paper elevation={0}>
          <Tabs id="TabsIdsSettings" scrollButtons>
            {
              getTabs().map((tab, index) => {
                return (
                  <TabContainer key={`menu-${index}`} label={tab.label} index={index}>
                    {tab.render()}
                  </TabContainer>
                )
              })
            }
          </Tabs>
        </Paper>
      </Container>
    {openModalDeleteRoute && <FSMDeleteRoute isMainView />}
    { openModalCreateEditRoute && <CreateEditRouteModalMain /> }
    </div>
  );
}

export default RoutesMainView;